import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { FormlyModule } from "@ngx-formly/core";
import { NgxsModule } from "@ngxs/store";
import { TagsState } from "@vp/data-access/tags";
import { FlexModule } from "@vp/shared/directives/flex";
import { DynamicTemplateModule } from "@vp/shared/directives/dynamic-template";
import { UtilitiesModule } from "@vp/shared/utilities";
import { TagSelectorState } from "./state/tag-selector-state";
import { TagSelectorComponent } from "./tag-selector.component";

@NgModule({
  imports: [
    CommonModule,
    FlexModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatSelectModule,
    NgxsModule.forFeature([TagsState, TagSelectorState]),
    DynamicTemplateModule,
    UtilitiesModule,
    FormlyModule.forChild()
    //   {
    //   types: [
    //     {
    //       name: "tag-selector",
    //       component: TagSelectorComponent
    //     }
    //   ]
    // }
  ],
  declarations: [TagSelectorComponent],
  exports: [TagSelectorComponent]
})
export class TagSelectorModule {}
